export const getPagination = ({ pagination }) => pagination;
export const pauta_empty = () => ({
  titulo: "",
  descricao: "",
  plenaria_id: null,
  titulo: null,
  ordem: null,
  tipo: "deliberativa",
  aprovado_unanimidade: null,
  rejeitado_unanimidade: null,
  votos_favor: null,
  votos_contra: null,
  abstencoes: null,
  votos_info: null,
});
